import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

function LeaveReasonForm({ token }) {
    const [q, setQ] = useState(null);
    const [pick, setPick] = useState("");
    const [other, setOther] = useState("");
    const [sent, setSent] = useState(false);
    useEffect(() => {
        api.get("/public/insiders/unsub-question").then(({ data }) => setQ(data)).catch(() => {});
    }, []);
    if (!q) return null;
    if (sent) return <p className="mt-6 text-[#f5e8c8]" data-testid="leave-reason-thanks">Mahalo for telling us.</p>;
    const submit = async () => {
        await api.post("/public/insiders/leave-reason", { token, reason: pick, other }).catch(() => {});
        setSent(true);
    };
    return (
        <div className="mt-8 text-left text-[#f5e8c8]" data-testid="leave-reason-form">
            <p className="font-serif text-lg">{q.question}</p>
            <div className="mt-3 space-y-2">
                {q.choices.map((c) => (
                    <label key={c} className="flex items-center gap-3 cursor-pointer">
                        <input type="radio" name="leave" checked={pick === c} onChange={() => setPick(c)} data-testid={`leave-reason-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} /> {c}
                    </label>
                ))}
            </div>
            {pick.toLowerCase() === "other" && (
                <textarea rows={2} maxLength={300} value={other} onChange={(e) => setOther(e.target.value)} placeholder="Tell us more (optional)"
                    className="mt-3 w-full bg-transparent border border-[#f5e8c8]/40 rounded-sm px-3 py-2 text-sm" data-testid="leave-reason-other-text" />
            )}
            <button onClick={submit} disabled={!pick} className="btn-pill btn-ghost mt-4" data-testid="leave-reason-submit">Send</button>
        </div>
    );
}

export default function InsidersUnsubscribe() {
    const [params] = useSearchParams();
    const [state, setState] = useState("working");
    const token = params.get("t");

    useEffect(() => {
        if (!token) {
            setState("missing");
            return;
        }
        api.post("/public/insiders/unsubscribe", { token })
            .then(({ data }) => setState(data.removed ? "done" : "missing"))
            .catch(() => setState("error"));
    }, [token]);

    const copy = {
        working: "One moment…",
        done: "You've left Island Gold Insiders. Mahalo for being with us — you're welcome back any time.",
        missing: "This link has already been used or isn't valid. You're not on the Insiders list.",
        error: "Something went wrong. Please try the link again in a moment.",
    };

    return (
        <section className="min-h-[60vh] max-w-xl mx-auto px-6 py-24 text-center" data-testid="insiders-unsubscribe-page">
            <h1 className="font-serif text-4xl text-gold">Island Gold Insiders</h1>
            <p className="mt-6 text-[#f5e8c8]" data-testid="insiders-unsubscribe-status">{copy[state]}</p>
            {state === "done" && <LeaveReasonForm token={token} />}
            <Link to="/" className="btn-pill btn-ghost mt-10 inline-flex" data-testid="insiders-unsubscribe-home">Back to Island Gold</Link>
        </section>
    );
}
